module.exports = __webpack_public_path__ + "img/image-7.9e107dfd.jpg";